import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "history-body__details" }
const _hoisted_2 = {
  key: 0,
  class: "history-body__details-empty"
}
const _hoisted_3 = { class: "history-body__details-empty_title" }
const _hoisted_4 = { class: "caption-medium color-text-secondary" }
const _hoisted_5 = {
  key: 1,
  class: "history-body__details-list"
}
const _hoisted_6 = { class: "history-body__details-list_day" }
const _hoisted_7 = { class: "h3 color-grey-light" }
const _hoisted_8 = { class: "history-body__details-list_title" }
const _hoisted_9 = { class: "h4" }
const _hoisted_10 = { class: "caption-small" }
const _hoisted_11 = { class: "history-body__details-list_numbers" }
const _hoisted_12 = { class: "caption-small" }

import { useI18n } from "vue-i18n";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import type { FinanceOperationGroup } from "@/struct/HistoryStruct";

export default /*@__PURE__*/_defineComponent({
  __name: 'HistoryFinancesList',
  props: {
    operations: {},
    formatInternalName: { type: Function }
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.operations.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("history.empty")), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operations, (day, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "history-body__details-list_item"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(day.date), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.operations, (op, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${day.date}-${idx}`,
                  class: "history-body__details-list_info"
                }, [
                  _createVNode(BaseFigureForIcon, {
                    class: "history-body__details-list_icon",
                    icon: `${op.type === 'minus' ? 'sim' : 'ruble'}`,
                    color: "grey-full",
                    radius: "16px",
                    size: "large"
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.formatInternalName(op.internal_name)), 1),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(op.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["h3", op.type === 'plus' ? 'plus' : ''])
                    }, [
                      (op.amount === 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(op.amount) + " ₽", 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(op.type === "minus" ? "-" : "+") + _toDisplayString(op.amount) + " ₽ ", 1)
                          ], 64))
                    ], 2),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(op.time), 1)
                  ])
                ]))
              }), 128))
            ]))
          }), 128))
        ]))
  ]))
}
}

})